import React from 'react'
import "../css/Publication.css";

import ReviewCardSingleCatalogue from "../components/ReviewCardSingleCatalogue";
export default function Catalogue() {
  return (
    <div>
      <div
        className="publication_lr-about-complete"
        style={{ display: "flex" }}
      >
        <div className="publication_about_literature_review">
          {/* <div className="publication_lr-title">Astro Photography Catalogue</div> */}
          <div
            className="publication_lr-about"
          
          >
          An astrophotography catalogue is a systematic collection and documentation of celestial images captured through telescopic observations and photographic techniques. It serves as a visual and technical record of astronomical phenomena, including lunar phases, planetary features, star clusters, and deep-sky objects, often accompanied by metadata such as capture dates, locations, equipment used, and exposure settings. By organizing and preserving these observations, the catalogue not only showcases the beauty of the cosmos but also provides a valuable resource for educational and scientific purposes, enabling future observers to build upon existing work, identify patterns, and inspire further exploration of the night sky. Like a literature review, it establishes a foundation for ongoing research while highlighting the achievements and methodologies of its creators.
          </div>
        </div>
        <div className="singlepdf">
          <ReviewCardSingleCatalogue />
        </div>
      </div>

    </div>
  )
}
